import {
  ColumnFiltersState,
  ColumnPinningState,
  PaginationState,
  RowSelectionState,
  SortingState,
} from "@tanstack/react-table";
import { create } from "zustand";
import { devtools } from "zustand/middleware";

type TableFilter = {
  tableId: string;
  globalFilter: string;
  columnFilters: ColumnFiltersState;
  sorting: SortingState;
  pagination: PaginationState;
  columnPinning: ColumnPinningState;
  rowSelection: RowSelectionState;
};

interface TableStore {
  tableData: TableFilter[];
  setTableData: (tableData: TableFilter) => void;
  removeTableData: (tableId: string) => void;
}

const useTableStore = create<TableStore>()(
  devtools(
    (set) => ({
      tableData: [],
      setTableData: (tableData) =>
        set((state) => {
          const existingTableIndex = state.tableData.findIndex(
            (t) => t.tableId === tableData.tableId
          );
          if (existingTableIndex >= 0) {
            const newTableData = [...state.tableData];
            newTableData[existingTableIndex] = tableData;
            return { tableData: newTableData };
          }
          return { tableData: [...state.tableData, tableData] };
        }),
      removeTableData: (tableId) =>
        set((state) => ({
          tableData: state.tableData.filter((t) => t.tableId !== tableId),
        })),
    }),
    { name: "table-storage" }
  )
);

export default useTableStore;
